<template>
  <div class="page" v-wechat-title="$route.meta.title">

    <!--搜索-->
    <div class="station-search border-box box">
      <div class="station-search-con box">
        <form class="station-search-bar border-box flex" action="." v-on:submit.prevent="search"
              @click="searchListShow=1">
          <img class="station-search-icon" src="../../assets/icon-search.png" alt="" @click.stop='search'>
          <input type="search" class="station-search-input" placeholder="搜索景区、解说员名" value="" v-model='inputValue'/>
          <img class="station-input-close none" src="../../assets/input-close.png" alt="" v-show="inputValue"
               @click.stop="inputValue=''">
        </form>
        <div class="search-history-cancel flex" v-if="searchListShow==1" @click="searchListShow=0">取消</div>
      </div>
      <div class="search-history-list border-box" v-if="searchListShow==1">
        <p class="search-history-tit" v-if="history.length > 0">
          搜索历史 <img src="../../assets/icon_01.png" alt="" @click="delHistory"></p>
        <p class="search-history-my clearfix">
          <span v-for="(item,index) in history" @click="searchHistory(item)">{{item}}</span>
        </p>
      </div>
    </div>


    <!--轮播图-->
    <div class="banner p024 border-box">
      <Swiper :banners="banners" :type="'home'"></Swiper>
    </div>

    <!-- 热门城市 -->
    <div class="main-hot-city border-box">
      <div v-if="hotcity!=null&&hotcity.length>1">
        <img class="main_hot_title" src="../../assets/main_hot_title.png"/>
        <div class="hot-citys clearfix">
          <p class="hot-citys-name hide" v-for="(item,index) in hotcity" @click="citySelected(item.city,item.code)">
            {{item.city}}</p>
        </div>
      </div>

        <div class="main-address border-box hide" @click="toCity">
          <img class="main_address_bg" src="../../assets/main_address_bg.png"/>
          <div class="main_address_box clearfix hide">
            <img class="main_address_icon" src="../../assets/location-icon1.png"/>
            <span class="hide border-box" v-show="loadEnd">{{cityInfo.city || '全国'}}</span>
          </div>
        </div>
    </div>

    <!--城市名片-->
    <div class="conference-list p024 mt26 new" v-if="cityCard!=null">
      <div class="conference-item-parent" @click="toCityCard(cityCard.region)">
        <div class='conference-item border-box'>
          <div class="conference-item-img loadBg">
            <img class="img" v-lazy="cityCard.logo" alt="">
          </div>
          <img class="conference-item-tab" src="../../assets/icon_csmp.png" alt="">
          <div class="conference-item-info clearfix">
            <div class="label-box fl">
              <div class="conference-item-title hide" style="max-width: 100%;">{{cityCard.name}}</div>
            </div>
            <div class="clearfix desc">
              <img src="../../assets/icon_03.png" alt="">
              <p class="hide2">{{cityCard.infoDetail}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--最新上线1（带图标的最新上线）-->
    <div class="conference-list p024 mt26 new" v-if="last&&last!=null&&loadEnd&&cityCard==null">
      <div class="conference-item-parent" @click="toViewDetail(last.id,last.shopType)">
        <div class='conference-item border-box'>
          <div class="conference-item-img loadBg">
            <img class="img" v-lazy="last.logo" alt="">
          </div>
          <img class="conference-item-tab" src="../../assets/icon_02.png" alt="">
          <div class="conference-item-info clearfix">
            <div class="label-box fl">
              <div class="conference-item-title hide" style="max-width: 100%;">{{last.name}}</div>
            </div>
            <div class="fr lineH60 right-info">
              <div class='conference-item-info-label'>
                <img src="../../assets/station-icon-view.png" alt="">
                <span class="icon-time">{{last.spots}}个讲解点</span>
              </div>
            </div>
            <div class="clearfix desc">
              <img src="../../assets/icon_03.png" alt="">
              <p class="hide2">{{last.info}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--VR虚拟全景视频-->
    <div class="conference-list p024 mt26 clearfix" v-if="vrRes.root!=null && vrRes.root.length>0">
      <div class="list-tit"><span></span>VR虚拟全景
        <router-link class="list-more" v-if="vrRes.total>1" :to="{path:'/video-vrlist',query: {code:cityInfo.citycode, siteid:siteid, sregion:sregion, appKey: appKeyA}}">更多>></router-link>
      </div>
      <router-link v-if="vrRes.root" class="vr border-box" :to="{path:'/video-vrlist',query: {code:cityInfo.citycode, siteid:siteid, sregion:sregion, appKey: appKeyA}}">
      <!--<router-link v-if="vrRes.root" class="vr border-box" :to="{path:'/video-vr',query: {id:vrRes.root[0].id,TimeStamp: TimeStamp, appKey: appKeyA}}">-->
        <img class="icon" src="../../assets/icon_360.png" alt="">
        <div class="img" id="vr-img" v-if="vrRes.root[0].vrimg&&vrRes.root[0].vrimg!=''&&vrRes.root[0].vrimg!=null"></div>
        <img class="img" v-lazy="vrRes.root[0].tvideourl" alt="" v-else>
      </router-link>
    </div>

    <!--金牌讲解员-->
    <div class="conference-list p024 mt26 new clearfix" v-if="bagList!=null&&bagList.length>0">
      <div class="list-tit"><span></span>金牌讲解员
        <div class="list-more" v-if="bagTotal>6" @click="toWaterfall()">查看更多</div>
      </div>
      <div>
      <div class="fl guide-box" v-for="(item,index) in bagList" @click="goVideoPlay(item.id,item.shopid)">
        <div class="guide-img">
          <img class="guide-tx" v-lazy="item.headimg" :key="item.id" alt="">
          <span class="guide-img-bot">
            <img class="fl" src="../../assets/icon_st.png" alt="">
            {{item.listens|initNumber}}
          </span>
        </div>
        <div class="guide-name hide">{{item.guidename}}</div>
        <div class="bag-name hide">{{item.bagname}}</div>
      </div>
      </div>
    </div>

    <!--最新上线2（普通样式的最新上线）-->
    <div class="conference-list p024 mt15" v-if="last&&last!=null&&loadEnd&&cityCard!=null">
      <div class="list-tit"><span></span>最新上线</div>
      <div class="conference-item-parent" @click="toViewDetail(last.id,last.shopType)">
        <div class='conference-item border-box'>
          <div class="conference-item-img loadBg">
            <img class="img" v-lazy="last.logo" alt="">
          </div>
          <div class="conference-item-info clearfix">
            <div class="label-box fl">
              <div class="conference-item-title hide" style="max-width: 100%;">{{last.name}}</div>
            </div>
            <div class="fr lineH60 right-info">
              <div class='conference-item-info-label'>
                <img src="../../assets/station-icon-view.png" alt="">
                <span class="icon-time">{{last.spots}}个讲解点</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!--热门景区-->
    <div class="conference-list p024 mt40" v-if="total1>0&&loadEnd">
      <div class="list-tit"><span></span>热门景区
        <router-link class="list-more" v-if="total1>2" :to="{path:'/view-list',query:{siteid:siteid,TimeStamp:TimeStamp,inputValue:inputValue,appKey:appKeyA,sort:0}}">查看更多</router-link>
      </div>
      <div>
        <div class="conference-item-parent" @click="toViewDetail(item.id,item.shopType)"  v-for="(item,index) in hot">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" :key="item.id" alt="">
            </div>
            <div class="conference-item-info clearfix">
              <div class="label-box fl">
                <div class="conference-item-title hide" style="max-width: 100%;">{{item.name}}</div>
              </div>
              <div class="fr lineH60 right-info">
                <div class='conference-item-info-label'>
                  <img src="../../assets/station-icon-view.png" alt="">
                  <span class="icon-time">{{item.spots}}个讲解点</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!--附近景区-->
    <div class="conference-list p024 half clearfix mt50" v-if="total2>0&&loadEnd">
      <div class="list-tit"><span></span>附近景区
        <!--<router-link class="list-more" v-if="total2>8" :to="{path:'/view-list',query:{siteid:siteid,TimeStamp:TimeStamp,inputValue:inputValue,appKey:appKeyA,sort:1}}">查看更多</router-link>-->
      </div>
      <div>
        <div  class="conference-item-parent" @click="toViewDetail(item.id,item.shopType)" v-for="(item,index) in near">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <div class="conference-item-info clearfix">
              <div class="label-box">
                <div class="conference-item-title hide" style="max-width: 100%;">{{item.name}}</div>
              </div>
              <div class="right-info">
                <div class='conference-item-info-label'>
                  <img src="../../assets/station-icon-view.png" alt="">
                  <span class="icon-time">{{item.spots}}个讲解点</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="load-tip">{{loadText}}</p>

    <!--<p class="load-tip" v-show="total1<=0&&total2<=0&&loadEnd">暂无数据</p>-->

    <!--红包活动弹窗(攀枝花类型的普通红包)-->
    <AlertRedEnvelNew  :redEnvelNew="redEnvelNew" @close="closeEnvelope" v-if="Object.keys(redEnvelNew).length>0"></AlertRedEnvelNew>

    <!--底部导航栏-->
    <Foot :siteid="siteid" :sregion="sregion" :appKeyA="appKeyA" ></Foot>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

  </div>


</template>
<!--<script type="text/javascript" src="//pingjs.qq.com/h5/hotclick.js?v2.0" name="mtah5hotclick" sid="500693284" hid="5d565901f063a"></script>-->
<script>
  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import Swiper from '../../components/Swiper'
  import Foot from '../../components/Foot'
  import P400 from '../../components/P400'
  import {getIndex,getHotCity,uploadUserBrowse,getEnvelope,getGuides,getNear} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo, getHotCity1} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertRedEnvelNew from '../../components/AlertRedEnvelNew'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        sregion: '', //省站点id:430000
        cityName: '',
        siteid: '', //站点id
        userInfo: {}, //用户信息
        latlng: {lat: '', lng: ''}, //经纬度信息
        cityInfo: { citycode: this.$route.query.code||"1", city: "全部", address: "" },
        banners: [],
        hotcity: [], //热门城市
        last: [],//最新上线
        hot: [],//热门景区
        near: [],//附近景区
        vrRes:'',//VR视频
        total1: 0, //热门景区总数
        total2: 0, //附近景区总数
        inputValue: '',//搜索关键词
        loadEnd: false, //数据加载结束则赋值为true
        redEnvelNew: [], //攀枝花类型的普通红包

        loadText: "加载更多",
        page: 1, //附近的加载更多

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',

        searchListShow: 0, //搜索历史
        history: [], //历史记录

        cityCard: null,//城市名片
        bagTotal: 0, //导游专辑总数
        bagList: [], //导游专辑列表

        P400: 0, //系统维护中
        PSV: null, //全景图片
      }
    },
    computed: {},

    beforeRouteLeave (to, from, next) {
      if(to.path.indexOf('waterfall') > -1){
        to.meta.keepAlive = false;
      }
      next();
    },
    created(){
      let self = this;
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey);
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
        this.getActivity();
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = { citycode: "1", city: "全国", address: "" };
          setStore("cityInfo",self.cityInfo);
          self.initData();
          self.getGuidesData();
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData();
          self.getGuidesData();
        });
      }

      let history = getStore("history", 1) || "";
      if (history) {
        this.history = history.history
      }

      window.addEventListener("scroll",this.handleFun)
//      statisticalData();
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {
      //初始化：获取景区数据
      async initData(){
        this.loadEnd = false;

        //获取热门城市
        var self = this;
        getHotCity1(this.sregion, function (resCity) {
          if (resCity.errcode == "00000") {
            self.hotcity = resCity.data.hotcity;
          } else {
            self.$toast(resCity.errmsg)
            self.P400 = 1;
            self.$route.meta.title = '请稍后访问...';
          }
        });

        //获取景区数据
        let resView = await getIndex({
          openid: this.userInfo.openid,
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode || '1',
          lat: this.latlng.lat || '',
          lng: this.latlng.lng || '',
          page1: 1,
          rows1: 2,
          page2: 1,
          rows2: 10,
          sregion: this.sregion
        });
        if (resView.errcode == "00000") {
          this.$loading.hide();
          this.loadEnd = true;

          this.cityCard = resView.data.cityCard;
          this.last = resView.data.last;
          this.hot = resView.data.hot.root;
          this.total1 = resView.data.hot.total;
          this.banners = resView.data.imgurls;
          this.total2 = resView.data.near.total;
          this.near = resView.data.near.root;
          if(this.near == null){
            this.near = [];
            this.loadText = '已经到底了'
          }
          this.vrRes = resView.data.vr;

          this.ids = resView.data.ids || "";

          if (this.sregion) {
            if (resView.data.city) {
              this.cityInfo.citycode = resView.data.citycode;
              this.cityInfo.city = resView.data.city;
              setStore("cityInfo", this.cityInfo);
            }
          }
          this.$route.meta.title = resView.data.head;
          let title = resView.data.title;
          let desc = resView.data.desc;
          let img = resView.data.logo;
          let link = '/?siteid=' + this.siteid + '&sregion=' + this.sregion + '&appKey=' + this.appKey;
          wxShareme(title, desc, img, link);

        } else {
          this.$loading.hide();
        }
      },

      async getNearlist(page){
        let res = await getNear({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode || '1',
          lat: this.latlng.lat || '',
          lng: this.latlng.lng || '',
          page: page,
          rows: 10,
          sregion: this.sregion,
          ids: this.ids
        });
        if (res.errcode == "00000") {
          this.$loading.hide();

          var total = res.data.near.total;
          var near = res.data.near.root;
          if (page >= Math.ceil(total / 10)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (near.length > 0) {
            this.near = [...this.near, ...near];
          } else {
            if (page == 1) {
              this.near = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

        } else {
          this.$loading.hide();
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          if(self.ids){
            loadMore(self,function(page){
              self.getNearlist(page);
            });
          }
        })
      },

      //上传浏览数据
      async sendUserBrowse(){
        let res = await uploadUserBrowse({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //获取红包活动数据
      async getActivity(){
        let res1 = await getEnvelope({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid,
          type: 0,
          shopId: ''
        });

        if (res1.errcode == '00000' && res1.errmsg == 'SUCCESS' && res1.data.length > 0) {
          if(res1.data[0].model == 1){ //红包活动弹窗（攀枝花类型的普通红包）
            res1.data[0].takeEnvelope = 0;
            this.redEnvelNew = res1.data[0].coupon;
          }
        }
      },
      //关闭活动弹窗
      closeEnvelope(msg){
        this.redEnvelopes = msg.redEnvelopes;
        if(msg.redEnvelNew1){
          this.redEnvelNew = [];
          if(msg.type == 0){
            this.$toast('领取成功，购买专辑立减哟');
          }
        }
      },

      //获取导游列表
      async getGuidesData(){
        let res = await getGuides({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode || '1',
          sregion: this.sregion
        });
        if (res.errcode == "00000") {
          this.$loading.hide();

          this.bagTotal = res.data.total;
          this.bagList = res.data.data;

        }
      },

      //选择城市
      citySelected(city, citycode){
        MtaH5.clickStat("home_hot_city");
        let cityInfo = {citycode: citycode, city: city, address: ""};
        setStore("cityInfo", cityInfo);
        this.cityInfo = cityInfo;
        this.inputValue = "";

        this.$loading.show('数据加载中');

        this.cityCard = null;
        this.last = {};
        this.hot = [];
        this.near = [];
        this.banners = [];
        this.page = 1;
        this.loadText = '加载更多';
        this.initData();

        this.bagTotal = 0;
        this.bagList = [];
        this.getGuidesData();
      },

      //删除历史记录
      delHistory(){
        let self = this;

        this.$confirm({
          title: '提示',
          content: '确认删除全部历史记录？',
          component: wxConfirm
        }).then(function (res) {
          if (res == 'success') {
            self.history = [];
            setStore("history", {"history": []}, 1);
          }
        }).catch(function (res) {
          if (res == 'success') {
            self.history = [];
            setStore("history", {"history": []}, 1);
          }
        })
      },

      //发送搜索信息inputVaule
      search(){
        this.inputValue = this.inputValue.replace(/(^\s*)|(\s*$)/g, "");
        if (this.inputValue == '') {
          this.$toast('请输入搜索关键词')
        } else {
          if (this.history.indexOf(this.inputValue) < 0) {
            this.history.push(this.inputValue);
          }
          setStore("history", {"history": this.history}, 1);
          this.searchHistory(this.inputValue);
        }
      },

      //搜索某一条
      searchHistory(inputValue){
        this.$router.push({
          path: `/home-search?${'inputValue=' + inputValue + '&TimeStamp=' + this.TimeStamp+'&siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion + '&appKey=' + this.appKey}`
        });
      },

      toViewDetail(id,shopType){
        MtaH5.clickStat('home_to_view');
        if(shopType == "buddhism"){
          this.$router.push({
            path: `/view-detail-sm?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }else {
          this.$router.push({
            path: `/view-detail?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }

      },

      toCity(){
        MtaH5.clickStat("home_location");
        this.$router.push({
          path: `/city?${'siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+ this.appKey}`
        });
      },

      //城市名片
      toCityCard(region){
        this.$router.push({
          path: `/city-card?${'citycode='+ region + '&TimeStamp='+ this.TimeStamp+'&appKey='+ this.appKey}`
        });
      },

      //跳转到专辑详情页
      goVideoPlay(id,shopid){
        this.$router.push({
          path: `/video-play?${'id='+id+'&shopid='+shopid+'&TimeStamp='+this.TimeStamp+'&siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion+'&appKey='+this.appKey}`
        });
      },

      //跳转到专辑瀑布流页面
      toWaterfall(){
        this.$router.push({
          path: `/waterfall?${'siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion + '&inputValue=' + this.inputValue + '&TimeStamp='+ this.TimeStamp+'&appKey='+ this.appKey}`
        });
      },

      showPhotoVR(imgurl,obj){
//        var imgurl = require('../../assets/qj.jpg');
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false  //不显示下面的导航栏
        });
      },

    },
    watch:  {
      vrRes(){
        var self = this;
        this.$nextTick(function(){
          if(self.vrRes.root!=null && self.vrRes.root.length>0 && self.vrRes.root[0].vrimg && self.vrRes.root[0].vrimg != '' && self.vrRes.root[0].vrimg != null){
            self.showPhotoVR(self.vrRes.root[0].vrimg,'vr-img');
          }
        })
      },
    },
    components: {
      Swiper,
        AlertRedEnvelNew,
        Foot,
        P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if (num > 10000) {
          num = (num / 10000).toFixed(2) + '万'
        } else if (num > 1000) {
          num = (num / 1000).toFixed(2) + '千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/view.css";

  .page{padding-bottom:2.4rem;background-color:#fff}

  /*搜索*/
  .station-search{position:fixed;top:0;left:0;z-index:99;padding:.2rem .24rem;width:100%;height:1.08rem;background:#fff}
  .station-search-con{position:relative;z-index:99}
  .station-search-bar{display:block;margin-top:0;height:.68rem;border-radius:.06rem;line-height:.68rem}
  .station-search-input{width:80%;height:.68rem;line-height:.68rem}
  .station-search-icon{position:absolute;top:50%;right:0;z-index:999;padding:.2rem .2rem .2rem 0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}
  .station-input-close{position:absolute;top:50%;right:.5rem;z-index:999;padding:.2rem;width:.19rem;height:.19rem;-webkit-transform:translateY(-50%);transform:translateY(-50%)}

  /*搜索记录*/
  .search-history-cancel{padding-left:.24rem;width:1.8rem;height:.68rem;color:#2671fb;text-align:center;font-size:.28rem;line-height:.68rem}
  .search-history-list{position:fixed;top:0;left:0;z-index:98;padding:1.48rem .3rem .3rem 0;width:100%;height:100%;background:#fff}
  .search-history-tit{position:relative;padding-left:.4rem;height:.4rem;color:#343434;line-height:.4rem}
  .search-history-tit img{position:absolute;top:.05rem;right:0;width:.28rem;height:.3rem}
  .search-history-my span{float:left;margin-top:.3rem;margin-left:.5rem;color:#000;font-size:.28rem}

  /* banner */
  .banner{position:relative;margin-top:1.08rem;height:3rem;border-radius:.07rem}

  /* 热门城市 */
  .main-hot-city{padding:.45rem .24rem 0}
  .main_hot_title{display:block;margin:0 auto;padding-bottom:.32rem;width:7.01rem;height:.36rem}
  .hot-citys .hot-citys-name{float:left;margin-right:.13rem;margin-bottom:.15rem;width:1.3rem;height:.6rem;background:#efefef;color:#999;text-align:center;font:normal .28rem/.6rem "Microsoft YaHei"}
  .hot-citys .hot-citys-name:nth-of-type(5n){margin-right:0}
  .main-address{position:relative;display:block;margin:.3rem auto 0;padding:0 .2rem;width:4rem;height:.76rem;border-radius:.3rem;color:#fff;text-align:center;font:.32rem/.76rem "Microsoft YaHei"}
  .main_address_bg{position:absolute;top:0;left:0;width:100%;height:100%;border-radius:.3rem}
  .main_address_box{display:inline-block;width:100%;height:.76rem;color:#fff}
  .main_address_icon{position:relative;z-index:1;width:.34rem;height:.39rem;vertical-align:text-bottom}
  .main-address span{position:relative;z-index:1;padding-left:.08rem;max-width:3.2rem}

  /*列表新样式*/
  .list-tit{padding:.2rem 0;height:.36rem;color:#333;font-weight:bold;font-size:.34rem;line-height:.36rem}
  .list-tit span{float:left;margin-right:.12rem;width:.07rem;height:.36rem;background-color:#faaf39}
  .list-more{float:right;padding:0 .07rem;color:#555;font-size:.24rem}
  .conference-item-info-label img{width:.17rem;height:.26rem;}

  /*最新景区*/
  .new .conference-item-parent .conference-item-title{ font-size: .32rem; color: #010101; }
  .new .conference-item-parent .conference-item-img{border-radius: .1rem; }
  .new .conference-item-parent .conference-item-tab{ position: absolute;left: .22rem;top: .2rem;z-index: 1;width: 1.13rem;height: .36rem; }
  .new .conference-item-parent .conference-item-info{height:1.4rem; padding-left: .17rem; border-radius: 0 0 .08rem .08rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1); }
  .new .conference-item-parent .desc{ position: relative; clear: both; padding-top: .08rem; }
  .new .conference-item-parent .desc img{ position: absolute;left: 0;top: 0;z-index: 2;width: .23rem;height: .22rem; }
  .new .conference-item-parent .desc p{ font-size: .2rem; line-height: .28rem; color: #666; text-indent: .42rem;}

  /*附近景区*/
  .half .conference-item-parent{float: left;width:50%;}
  .half .conference-item-parent:nth-of-type(odd) .conference-item{padding-right:3%;}
  .half .conference-item-parent:nth-of-type(even) .conference-item{padding-left:3%;}
  .half .conference-item-parent .conference-item-img{height:2.7rem; border-radius: .08rem .08rem 0 0; }
  .half .conference-item-parent .conference-item-info{height:1rem; padding-left: .17rem; border-radius: 0 0 .08rem .08rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1); }
  .half .conference-item-parent .conference-item-title{font-size:.26rem;}
  .half .conference-item-parent .label-box{width: 100%;height:.48rem; line-height: .48rem; padding-top: .08rem; }
  .half .conference-item-parent .right-info{width: 100%;text-align: left;}

  /*金牌讲解员*/
  .guide-box{width:30%;height: 2.85rem;margin-right: 5%;margin-bottom: .25rem;}
  .guide-box:nth-of-type(3n){margin-right: 0;}
  .guide-img{position:relative;width: 100%;height: 2.08rem;border-radius: .12rem;overflow: hidden;}
  .guide-img .guide-tx{width: 100%;height: 100%;object-fit: cover;border-radius: .12rem;}
  .guide-img-bot{position: absolute;left: 0;bottom: 0;width: 100%;height: .38rem;line-height: .38rem;font-size:.18rem;color:#fffefe;background: rgba(0,0,0,.77);}
  .guide-img-bot img{margin-left: .15rem;width: auto;height: .16rem;margin-top: .11rem;margin-right: .08rem;}
  .guide-name{margin-top:.06rem;font: bold .3rem "Microsoft YaHei";color: #3d3d3d;}
  .bag-name{margin-top:.06rem;font-size: .2rem;color: #3d3d3d;}

  /*vr*/
  .conference-list .vr{ position: relative; display: block;width:100%;height: 3.02rem;border-radius: .1rem;overflow: hidden;}
  .conference-list .vr .img{position:relative;z-index:1;border-radius: .1rem;overflow: hidden;}
  .conference-list .vr .icon{position: absolute;z-index: 2;top:50%;left: 50%;width: auto;height:.61rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}

</style>



// WEBPACK FOOTER //
// src/page/home/home-s.vue